module.exports = __webpack_public_path__ + "static/media/lab-bg.709b815e.png";